<template>
  <div class="add">
    <van-field
      v-model.trim="form.title"
      label=""
      placeholder="填写标题会有更多赞哦"
    />
    <van-field
      v-model="form.text"
      autosize
      border="false"
      label=""
      placeholder="请输入正文"
      rows="8"
      type="textarea"
    />
    <!-- <van-cell>
      <div
        id="editor"
        class="edit"
        contenteditable="true"
        style="min-height: 200px"
        @blur="contentBlur"
        @click="keydown"
        v-html="form.text"
      ></div>
    </van-cell> -->
    <van-cell value="q">
      <div class="resources-box" style="margin-bottom: -6px">
        <div>
          <zy-uploader
            v-model:file="form.imageList"
            :limit-size="500 * 1024"
            :max-count="9"
            :max-size="10 * 1024 * 1024"
          />
        </div>
        <div>
          <zy-video-uploader
            v-model:file="form.videoList"
            :max-count="9"
            :max-size="400 * 1024 * 1024"
          />
          <div style="font-size: 12px; color: #999; margin: -5px 0 10px">
            上传400M以内视频
          </div>
        </div>
      </div>
    </van-cell>

    <!-- <van-cell value="">
      <ul class="btn-list flex">
        <li :class="{ current: active == 1 }" @click="active = 1">
          <van-icon name="newspaper-o" size="32" />
          <p>图片</p>
        </li>
        <li :class="{ current: active == 2 }" @click="active = 2">
          <van-icon name="video-o" size="32" />
          <p>视频</p>
        </li>
      </ul>
    </van-cell> -->

    <van-cell
      icon="comment-circle"
      is-link
      title="选择标签"
      :value="form.topicName"
      @click="showTopicHandle"
    />
    <van-action-sheet v-model:show="showTopic" title="选择标签">
      <div class="topic-content">
        <div v-if="loading" class="loading-box">
          <van-loading color="#b57e48" type="spinner" />
        </div>
        <div class="content">
          <ul class="flex flex-pack-center flex-wrap">
            <li v-for="item in topicList" :key="item.TagId">
              <a
                :class="{ current: form.topicId == item.TagId }"
                href="javascript:;"
                @click="selectTopic(item)"
              >
                <span>#</span>
                <span>{{ item.TagLabel }}</span>
                <span>#</span>
                <van-icon
                  v-if="item.IsHotTag"
                  color="#ee0a24"
                  name="fire"
                  size="14"
                />
              </a>
            </li>
            <li>
              <div v-if="!topicList.length" class="no-data">
                暂无标签，请联系管理员添加...
              </div>
            </li>
          </ul>

          <!-- <div class="btn-box flex">
            <div class="cancel">
              <van-button block plain round type="primary">取消</van-button>
            </div>
            <div class="flex-1">
              <van-button block round type="primary">确定</van-button>
            </div>
          </div> -->
        </div>
      </div>
    </van-action-sheet>
  </div>
  <div class="btn-box flex fixed">
    <div class="cancel">
      <van-button block plain round type="primary" @click="cancel">
        取消
      </van-button>
    </div>
    <div class="flex-1">
      <van-button
        block
        :loading="submitLoading"
        round
        type="primary"
        @click="submit"
      >
        发布
      </van-button>
    </div>
  </div>
</template>
<script>
  import { ref } from 'vue'
  import ZyUploader from '@/components/ZyUploader'
  import ZyVideoUploader from '@/components/ZyVideoUploader'
  import store from '@/store'
  import { useRouter, useRoute } from 'vue-router'
  import { router, watch, onMounted, onBeforeUnmount } from 'vue'
  import { Toast, Dialog } from 'vant'
  import storage from '@/utils/storage'
  export default {
    components: {
      ZyUploader,
      ZyVideoUploader,
    },
    setup() {
      const showTopic = ref(false)
      const active = ref(1)
      const loading = ref(true)
      const topicList = ref([])
      const router = useRouter()
      const route = useRoute()
      const form = ref({
        id: null,
        title: '',
        text: '',
        imageList: '',
        topicId: '',
        topicName: '',
        image: [],
        video: [],
        videoList: '',
        audio: [],
      })
      const submitLoading = ref(false)

      // get id 有id时为编辑
      const getDetail = (id) => {
        store
          .dispatch('case/PostGet', {
            id,
          })
          .then(async (data) => {
            const Data = data.Data
            form.value.id = Data.Id
            form.value.title = Data.Title
            form.value.text = Data.Text
            await getTopicList()
            topicList.value.forEach((item) => {
              if (item.TagId === Data.TopicId) {
                form.value.topicName = item.TagLabel
              }
            })
            form.value.topicId = Data.TopicId
            form.value.imageList = Data.Image.join(',')
            form.value.videoList = Data.Video.join(',')
          })
          .catch((e) => {
            Toast.fail('获取帖子详情失败')
          })
      }

      const id = route.query.id
      if (id) {
        getDetail(id)
      }
      // onMounted(() => {
      //   //getCase()
      //   const cased = JSON.parse(storage.get('case')) || ''
      //   Object.assign(form.value, cased)
      //   console.log('onMounted')
      //   document.getElementById('editor').addEventListener('paste', eventPaste)
      // })

      // onBeforeUnmount(() => {
      //   console.log('onBeforeUnmount')
      //   document
      //     .getElementById('editor')
      //     .removeEventListener('paste', eventPaste)
      // })

      const eventPaste = (e) => {
        if (e.clipboardData) {
          // 阻止默认行为
          e.preventDefault()
          var clipboardData = e.clipboardData
          // 获取剪贴板的文本
          var text = clipboardData.getData('text')
          if (window.getSelection && text !== '' && text !== null) {
            // 创建文本节点
            var textNode = document.createTextNode(text)
            // 在当前的光标处插入文本节点
            var range = window.getSelection().getRangeAt(0)
            // 删除选中文本
            range.deleteContents()
            // 插入文本
            range.insertNode(textNode)
          }
        }
      }
      // 保存案例内容
      watch(
        form,
        (newVal, oldVal) => {
          saveCase()
        },
        {
          deep: true,
        }
      )

      const saveCase = () => {
        storage.set('case', JSON.stringify(form.value))
      }

      const contentBlur = ($event) => {
        setTimeout(() => {
          form.value.text = $event.target.innerHTML
        })
      }

      const removeCase = () => {
        storage.remove('case')
      }

      const getCase = () => {
        const cased = JSON.parse(storage.get('case')) || ''
        //if (cased) {
        Dialog.confirm({
          title: '温馨提示',
          message: `存在缓存内容，是否加载内容继续发布`,
          confirmButtonText: '继续发布',
          cancelButtonText: '重新开始',
        })
          .then(() => {
            Object.assign(form.value, cased)
            //console.log(123)
          })
          .catch(() => {
            // 只有在发布完成后才真正的清除内容
            //removeCase()
          })
        //}
      }

      // 点击选择话题时加载话题数据
      const showTopicHandle = () => {
        showTopic.value = true
        if (!topicList.value.length) {
          getTopicList()
        }
      }
      // 下拉选择话题
      const selectTopic = (item) => {
        form.value.topicId = item.TagId
        form.value.topicName = item.TagLabel
        showTopic.value = false
      }

      // 获取话题
      const getTopicList = async () => {
        const params = {
          TenantId: (await store.getters['user/getTenant']).TenantId,
          pageIndex: 1,
          pageSize: 100,
          tagLabel: '',
          isHotTag: -1,
        }
        return store
          .dispatch('case/TopicTagGetList', params)
          .then((data) => {
            loading.value = false
            topicList.value = data.Data.CurrentPage
          })
          .catch((e) => {
            loading.value = false
            console.log(e)
          })
      }

      const cancel = () => {
        router.back()
      }
      const submit = async () => {
        if (submitLoading.value) return
        setTimeout(async () => {
          if (!form.value.title) {
            Toast('请输入标题!')
            return
          }
          if (!form.value.text) {
            Toast('请输入正文!')
            return
          }
          if (!form.value.topicId) {
            Toast('请选择标签!')
            return
          }
          if (form.value.imageList.length) {
            form.value.image = form.value.imageList.split(',')
          }
          if (form.value.videoList.length) {
            form.value.video = form.value.videoList.split(',')
          }
          form.value.tenantId = (await store.getters['user/getTenant']).TenantId
          form.value.industry = store.getters['user/getIndustry']
          submitLoading.value = true
          let url = 'case/PostPublish'
          if (form.value.id) {
            url = 'case/PostUpdate'
          }
          store
            .dispatch(url, form.value)
            .then((data) => {
              Toast.success('发布成功')
              removeCase()
              setTimeout(() => {
                submitLoading.value = false
                router.replace({
                  name: 'Mypost',
                })
              }, 1000)
            })
            .catch((e) => {
              const msg = e.Message || '操作失败'
              Toast.error(msg)
              submitLoading.value = false
              console.log(e)
            })
        }, 300)
      }
      return {
        form,
        showTopic,
        active,
        showTopicHandle,
        loading,
        topicList,
        selectTopic,
        cancel,
        submit,
        submitLoading,
        contentBlur,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .van-button--primary {
    background-color: #b57e48;
    border: 1px solid #b57e48;
  }
  .van-button--plain.van-button--primary {
    background-color: #fff;
    color: #b57e48;
  }
  .add {
    background: #fff;
    padding: 10px 0 90px;
    min-height: 88vh;
    box-sizing: border-box;
  }
  .btn-list {
    li {
      text-align: center;
      line-height: 1;
      color: #666;
      padding: 0 8px;
      margin-right: 10px;
      i {
        font-size: 24px;
      }
      p {
        color: #333;
        font-size: 14px;
        margin: 6px 0 0;
      }
      &.current {
        color: #b57e48;
        p {
          color: #b57e48;
        }
      }
    }
  }
  .btn-box {
    background: #fff;
    padding: 16px;
    .cancel {
      width: 26%;
      padding-right: 10px;
    }
    &.fixed {
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
  .topic-content {
    //min-height: 200px;
    .content ul {
      padding: 20px 20px;
      li {
        margin: 10px 16px;
        a {
          color: #666;
          &.current {
            color: #b57e48;
          }
        }
      }
    }
    .btn-box {
      padding: 10px 16px;
    }
  }
  .loading-box {
    text-align: center;
    padding: 50px;
  }
  .resources-box {
    div + div {
      margin: 10px 0 0;
    }
  }
  .no-data {
    padding-bottom: 10px;
    color: #666;
    font-size: 14px;
  }
  .edit {
    &:empty:before {
      content: '请输入正文';
      color: #ccc;
    }
    &:focus:before {
      content: none;
    }
  }
</style>
